export default __webpack_public_path__ + "static/media/Welcome-gif-1.fd1a20f3.png";